import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import AttributeList from './components/AttributeList';

import styles from './_index.module.scss';

const Attributes = ({
  hasCompatibleCustomGroupsOnly = false,
  isLoading,
  isLoadingCustom,
  options,
  setActiveAttribute,
}) => {
  const userData = useSelector((state) => state?.user?.data);

  const attributes = options.filter((option) => !option?.isCustom);
  const customAttributes = options.filter((option) => option?.isCustom && !option?.isFixed);
  const fixedAttributes = options.filter((option) => option?.isFixed);

  const renderCustomGroupHeading = (groupType) => {
    if (groupType === 'Fixed') {
      return `${userData?.clientInfo?.name} Hierarchy${hasCompatibleCustomGroupsOnly ? ': Compatible Groups' : ''}`;
    }
    return `${hasCompatibleCustomGroupsOnly ? 'Compatible' : 'User'} Custom Groups`;
  };
  return (
    <div className={styles['attributes']}>
      <AttributeList
        attributes={attributes}
        isLoading={isLoading}
        setActiveAttribute={setActiveAttribute}
      />
      {fixedAttributes?.length > 0 && (
        <>
          <h4>{renderCustomGroupHeading('Fixed')}</h4>
          <AttributeList
            attributes={fixedAttributes}
            isLoading={isLoadingCustom}
            setActiveAttribute={setActiveAttribute}
          />
        </>
      )}
      {customAttributes?.length > 0 && (
        <>
          <h4>{renderCustomGroupHeading()}</h4>
          <AttributeList
            attributes={customAttributes}
            isLoading={isLoadingCustom}
            setActiveAttribute={setActiveAttribute}
          />
        </>
      )}
    </div>
  );
};

Attributes.propTypes = {
  hasCompatibleCustomGroupsOnly: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingCustom: PropTypes.bool,
  options: PropTypes.array,
  setActiveAttribute: PropTypes.func,
};

export default Attributes;
